<template>
  <div>
    <CRow>
      <CCol xs="12" lg="10">
        <CCard>
          <CCardHeader>
            <div class="d-inline" v-if="this.invoice_language == 'greek'">
              <strong>Αριθμός Τιμολογίου</strong> {{document_number}}
              <CBadge v-if="created_externally" color="info" class="ml-2">Εξωτερικό B2G</CBadge>
            </div>
            <div class="d-inline" v-if="this.invoice_language == 'english'">
              <strong>Invoice Number</strong> {{document_number}}
              <CBadge v-if="created_externally" color="info" class="ml-2">External B2G</CBadge>
            </div>
            <div class="float-right">
                <div v-if="showMyDataTab">
                  <a
                    v-if="mark === '' || mark === null"
                    class="btn btn-sm btn-info ml-1 colorWhite"
                    @click="sentToMyData()"
                  >
                    <CIcon name="cil-save" class="colorWhite mr-1"/>
                    Αποστολή στο MyData
                  </a>
                  <span  v-if="mark !== '' && mark !== null">MARK : {{ mark }}</span>
                </div>
            </div>
            <div class="float-right">
              <a
                class="btn btn-sm btn-info ml-1 colorWhite"
                @click="printInvoice()"
              >
                <CIcon name="cil-save" class="colorWhite mr-1"/> Αποθήκευση
              </a>
            </div>
          </CCardHeader>
          <CCardBody>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CRow class="mb-4">
              <CCol sm="5">
                <h5 class="mb-3" v-if="this.invoice_language == 'greek'">Στοιχεία πελάτη:</h5>
                <h5 class="mb-3" v-if="this.invoice_language == 'english'">Client Information:</h5>
                <div v-if="this.invoice_language == 'greek'"><strong>Επωνυμία εταιρίας:</strong> {{client_company}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>Company:</strong> {{client_company}}</div>
                <div v-if="this.invoice_language == 'greek' && this.client_name"><strong>Υπεύθυνος Επικοινωνίας:</strong> {{client_name}}</div>
                <div v-if="this.invoice_language == 'english' && this.client_name"><strong>Contact Person:</strong> {{client_name}}</div>
                <div v-if="this.invoice_language == 'greek'"><strong>Οδός και αριθμός:</strong> {{client_address}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>Address:</strong> {{client_address}}</div>
                <div v-if="this.invoice_language == 'greek' && this.client_postcode"><strong>Πόλη, νομός, Τ.Κ.:</strong> {{client_town}}, {{client_state}}, {{client_postcode}} </div>
                <div v-if="this.invoice_language == 'greek' && !this.client_postcode"><strong>Πόλη, νομός:</strong> {{client_town}}, {{client_state}} </div>
                <div v-if="this.invoice_language == 'english' && this.client_postcode"><strong>Town, State, Postcode:</strong> {{client_town}}, {{client_state}}, {{client_postcode}} </div>
                <div v-if="this.invoice_language == 'english' && !this.client_postcode"><strong>Town, State:</strong> {{client_town}}, {{client_state}} </div>
                <div v-if="this.invoice_language == 'greek'"><strong>Τηλέφωνο Επικοινωνίας (1):</strong> {{client_phone}}</div>
                <div v-if="this.invoice_language == 'greek' && this.client_phone_2"><strong>Τηλέφωνο Επικοινωνίας (2):</strong> {{client_phone_2}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>Phone (1):</strong> {{client_phone}}</div>
                <div v-if="this.invoice_language == 'english' && this.client_phone_2"><strong>Phone (2):</strong> {{client_phone_2}}</div>
                <div v-if="this.invoice_language == 'greek'"><strong>ΑΦΜ:</strong> {{client_afm}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>VAT number:</strong> {{client_afm}}</div>
                <div v-if="this.invoice_language == 'greek'"><strong>ΔΟΥ:</strong> {{client_doy}}</div>
              </CCol>
              <CCol sm="4">
                <h5 class="mb-3" v-if="this.invoice_language == 'greek'">Πληροφορίες τιμολογίου:</h5>
                <h5 class="mb-3" v-if="this.invoice_language == 'english'">Invoice Information:</h5>
                <div v-if="this.invoice_language == 'greek'"><strong>Ημερομηνία Έκδοσης:</strong> {{invoice_date}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>Date of issue:</strong> {{invoice_date}}</div>
                <div v-if="this.invoice_language == 'greek'"><strong>Τύπος παραστατικού:</strong> {{document_series}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>Document type:</strong> {{document_series}}</div>
                <div v-if="this.invoice_language == 'greek'"><strong>Σειρά παραστατικού:</strong> {{document_series_seira}}</div>
                <div v-if="this.invoice_language == 'english'"><strong>Document series:</strong> {{document_series_seira}}</div>

                <!-- B2G Specific Information -->
                <div v-if="created_externally" class="mt-3 pt-3" style="border-top: 1px solid #d8dbe0;">
                  <h6 class="mb-2" v-if="this.invoice_language == 'greek'"><strong>Πληροφορίες B2G:</strong></h6>
                  <h6 class="mb-2" v-if="this.invoice_language == 'english'"><strong>B2G Information:</strong></h6>
                  <div v-if="protocol_number" class="small">
                    <strong v-if="this.invoice_language == 'greek'">Αρ. Πρωτοκόλλου:</strong>
                    <strong v-if="this.invoice_language == 'english'">Protocol Number:</strong>
                    {{protocol_number}}
                  </div>
                  <div v-if="protocol_date" class="small">
                    <strong v-if="this.invoice_language == 'greek'">Ημ/νία Πρωτοκόλλου:</strong>
                    <strong v-if="this.invoice_language == 'english'">Protocol Date:</strong>
                    {{protocol_date}}
                  </div>
                  <div v-if="diavgeia_ref" class="small">
                    <strong>Diavgeia ΑΔΑ:</strong> {{diavgeia_ref}}
                  </div>
                  <div v-if="government_contract_ref" class="small">
                    <strong v-if="this.invoice_language == 'greek'">Αρ. Σύμβασης:</strong>
                    <strong v-if="this.invoice_language == 'english'">Contract Ref:</strong>
                    {{government_contract_ref}}
                  </div>
                </div>
              </CCol>
            </CRow>
            <h4 class="text-center mb-3" v-if="this.invoice_language == 'greek'">Υπηρεσίες</h4>
            <h4 class="text-center mb-3" v-if="this.invoice_language == 'english'">Services</h4>
            <div class="invoicesTablePreview">
              <div class="table-responsive-sm">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th v-if="this.invoice_language == 'greek'">Υπηρεσία</th>
                      <th v-if="this.invoice_language == 'english'">Service</th>
                      <th class="center" v-if="this.invoice_language == 'greek'">Ποσότητα</th>
                      <th class="center" v-if="this.invoice_language == 'english'">Quantity</th>
                      <th class="right" v-if="this.invoice_language == 'greek'">Τιμή Τεμαχίου</th>
                      <th class="right" v-if="this.invoice_language == 'english'">Unit Price</th>
                      <th class="right lastElementTable" v-if="this.invoice_language == 'greek'">Ποσό</th>
                      <th class="right lastElementTable" v-if="this.invoice_language == 'english'">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item) in invoices_cases" :key="item.id">
                      <td class="left">{{ getServiceName(item.id) }}</td>
                      <td class="center">{{ item.service_quantity }}</td>
                      <td class="right">{{ (item.price_without_vat / item.service_quantity).toFixed(2) }}€</td>
                      <td class="right lastElementTable">{{ item.price_without_vat }}€</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <CRow>
              <CCol lg="4" sm="5">

              </CCol>
              <CCol lg="3" sm="3" class="ml-auto" style="text-align: right">
                <table class="table table-clear">
                  <tbody>
                    <tr>
                      <td class="left" v-if="this.invoice_language == 'greek'"><strong>Μερικό άθροισμα</strong></td>
                      <td class="left" v-if="this.invoice_language == 'english'"><strong>Sub Total</strong></td>
                      <td class="right">{{subtotal}}€</td>
                    </tr>
                    <tr v-if="this.invoice_language == 'greek'">
                      <td class="left"><strong>ΦΠΑ {{this.fpa100}}%</strong></td>
                      <td class="right">{{this.fpa}}€</td>
                    </tr>
                    <tr>
                      <td class="left" v-if="this.invoice_language == 'greek'"><strong>Σύνολο</strong></td>
                      <td class="left" v-if="this.invoice_language == 'english'"><strong>Total</strong></td>
                      <td class="right">{{total}}€</td>
                    </tr>
                  </tbody>
                </table>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

      <qrcode-vue v-if="qr_url.length > 0" :value="qr_url" :size="qrSize" level="H" render-as="canvas" class="qr-image" style="position: absolute; bottom: 0; right: 0; visibility: hidden;" />
  </diV>
</template>

<script>
import axios from 'axios'
import {Roboto} from './Roboto-Regular-normal.js'
import {RobotoItalic} from './Roboto-Italic-normal.js'
import {RobotoBold} from './Roboto-Bold-normal.js'
import { jsPDF } from "jspdf";
import  QrcodeVue from "qrcode.vue"
import 'jspdf-autotable'

export default {
  name: 'ViewInvoice',
  data: () => {
    return {
      qr_url: '',
      qrSize: 150,
      document_series_options: null,
      mark: '',
      items: [],
      title: '',
      fpa_percentage: 0,
      doc_series_raw: null,
      doc_series_seira_raw: null,
      service_name_raw: [],
      created_externally: false,
      document_number: '',
      client_type: '',
      client_name: '',
      client_address: '',
      client_town: '',
      client_state: '',
      client_postcode: '',
      client_company: '',
      client_phone: '',
      client_phone_2: '',
      client_afm: '',
      client_doy: '',
      invoice_date: '',
      document_series: '',
      document_series_seira: '',
      document_series_code: '',
      invoice_language: '',
      government_contract_ref: '',
      diavgeia_ref: '',
      protocol_number: '',
      protocol_date: '',
      BQVLogoUrl: '',
      BQVInfoName: '',
      BQVInfoMotto: '',
      BQVInfoMottoEn: '',
      BQVaddress: '',
      BQVaddressEN: '',
      BQVphone_number_1: '',
      BQVphone_number_2: '',
      BQVvat: '',
      BQVvatEN: '',
      BQVdoy: '',
      BQVemail: '',
      BQVwebsite: '',
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      BQVbank_accounts: '',
      alertIsShown: false,
      BQVbank_accountsEN: '',
      invoices_cases: [],
      isBQVLogoUploaded: 0,
      total: 0,
      subtotal: 0,
      fpa100: 0,
      fpa: 0,
      RobotoItalic,
      RobotoBold,
      Roboto,
    }
  },
  components: {
    QrcodeVue,
  },
  computed: {
    showMyDataTab(){
      // Don't show myDATA button for external invoices (already created in AADE)
      if(this.created_externally === true){
        return false
      }

      // Check if document_series_raw exists before accessing its properties
      if(this.doc_series_raw === null || this.doc_series_raw === undefined){
        return false
      }

      if(this.document_series_options !== null && this.document_series_options !== undefined){
        var canceledInvoicesList = this.document_series_options.filter(opt => opt.greek_name.includes('Ακυρωτικό')).map(item => item['id'])

        if(canceledInvoicesList.includes(this.doc_series_raw.id)){
          return false
        }
      }
      return true
    },

    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getServiceName(id) {
      let self = this;

      if (!self.service_name_raw || !Array.isArray(self.service_name_raw)) {
        return '';
      }

      var tempService = self.service_name_raw.find((item) => { if (item && item.id == id) { return item; } });

      if (!tempService) {
        return '';
      }

      if (tempService.service_type && tempService.service_type.includes("Cases")) {
        return tempService.service_description || '';
      } else if (tempService.service_type && tempService.service_type.includes("InvoiceService")) {
        return tempService.service_description || '';
      }

      // For external B2G invoices or other types, return service_description if available
      return tempService.service_description || '';
    },
    getinvoiceClientData (id) {
      const invoiceClient = invoiceClientsData.find((invoiceClient, index) => index + 1 == id)
      const invoiceClientDetails = invoiceClient ? Object.entries(invoiceClient) : [['id', 'Not found']]
      return invoiceClientDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    },
    getAllDocumentSeries(val, lang) {
      let self = this;

      if (val && lang == 'greek') {
        return self.doc_series_raw.greek_name;
      } else if (val && lang == 'english') {
        return self.doc_series_raw.english_name;
      }
    },
    getAllDocumentSeriesSeira(val, lang) {
      let self = this;

      if (val && lang == 'greek') {
        return self.doc_series_seira_raw.name;
      } else if (val && lang == 'english') {
        return self.doc_series_seira_raw.name;
      }
    },
    getAllDocumentSeriesCode(val, lang) {
      let self = this;

      if (val && lang == 'greek') {
        return self.doc_series_raw.short_name;
      } else if (val && lang == 'english') {
        return self.doc_series_raw.short_name_english;
      }
    },
    getInvoice() {
      let self = this;
      axios.get('/api/invoices/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.document_series_options = response.data.document_series_options;
        self.service_name_raw = response.data.invoice.invoices_cases || [];
        self.invoice_language = response.data.invoice.invoice_language;
        self.fpa_percentage = response.data.invoice.fpa_percentage;
        self.fpa100 = self.fpa_percentage*100;
        self.doc_series_raw = response.data.invoice.document_series || null;
        self.doc_series_seira_raw = response.data.invoice.document_series_seira || null;
        self.created_externally = response.data.invoice.created_externally || false;
        self.document_number = response.data.invoice.document_number;
        self.qr_url = response.data.invoice.qr_url === null ? '' : response.data.invoice.qr_url;
        self.mark = response.data.invoice.mark;
        self.government_contract_ref = response.data.invoice.government_contract_ref || '';
        self.diavgeia_ref = response.data.invoice.diavgeia_ref || '';
        self.protocol_number = response.data.invoice.protocol_number || '';
        self.protocol_date = response.data.invoice.protocol_date || '';
        self.client_type = response.data.invoice.client_type;
        self.client_name = response.data.invoice.client_name;
        self.client_address = response.data.invoice.client_address;
        self.client_town = response.data.invoice.client_town;
        self.client_state = response.data.invoice.client_state;
        self.client_postcode = response.data.invoice.client_postcode;
        self.client_company = response.data.invoice.client_company;
        self.client_phone = response.data.invoice.client_phone;
        self.client_phone_2 = response.data.invoice.client_phone_2;
        self.client_afm = response.data.invoice.client_afm;
        self.client_doy = response.data.invoice.client_doy;
        self.invoice_date = response.data.invoice.invoice_date;
        self.document_series_seira = self.getAllDocumentSeriesSeira(response.data.invoice.document_series_seira_id, response.data.invoice.invoice_language);
        self.document_series = self.getAllDocumentSeries(response.data.invoice.document_series_id, response.data.invoice.invoice_language);
        self.document_series_code = self.getAllDocumentSeriesCode(response.data.invoice.document_series_id, response.data.invoice.invoice_language);
        self.isBQVLogoUploaded = response.data.company_info.media.length;
        if (self.isBQVLogoUploaded != 0) {
          self.BQVLogoUrl = response.data.company_info.media[0].url;
        }
        self.BQVInfoName = response.data.company_info.name;
        self.BQVInfoMotto = response.data.company_info.motto;
        self.BQVInfoMottoEn = response.data.company_info.motto_english;
        self.BQVaddress = response.data.company_info.address;
        self.BQVaddressEN = response.data.company_info.address_english;
        self.BQVphone_number_1 = response.data.company_info.phone_number_1;
        self.BQVphone_number_2 = response.data.company_info.phone_number_2;
        self.BQVvat = response.data.company_info.vat;
        self.BQVvatEN = response.data.company_info.vat_english;
        self.BQVdoy = response.data.company_info.doy;
        self.BQVemail = response.data.company_info.email;
        self.BQVwebsite = response.data.company_info.website;
        self.BQVbank_accounts = response.data.company_info.bank_accounts;
        self.BQVbank_accountsEN = response.data.company_info.bank_accounts_english;

        // Process invoices_cases with null safety
        if (response.data.invoice.invoices_cases && Array.isArray(response.data.invoice.invoices_cases)) {
          self.invoices_cases = response.data.invoice.invoices_cases
            .filter(item => item !== null && item !== undefined)
            .map((item) => {
              let tempQuantity = item.service_quantity;
              if (item.service && 'case_code' in item.service)
                item.service_quantity = tempQuantity;
              return item;
            });
        } else {
          self.invoices_cases = [];
        }

        self.subtotal = self.calculateSubtotal(self.invoices_cases);
        self.total = self.calculateTotal(self.invoices_cases);
        self.fpa = (self.subtotal*self.fpa_percentage).toFixed(2);
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    calculateTotal(services) {
      if (!services || !Array.isArray(services)) {
        return '0.00';
      }
      let sum = services
        .filter(item => item !== null && item !== undefined && item.total_price)
        .reduce(function (accumulator, item) {
          return accumulator + parseFloat(item.total_price)
        }, 0);
      return sum.toFixed(2);
    },
    calculateSubtotal(services) {
      if (!services || !Array.isArray(services)) {
        return '0.00';
      }
      let sum = services
        .filter(item => item !== null && item !== undefined && item.price_without_vat)
        .reduce(function (accumulator, item) {
          return accumulator + parseFloat(item.price_without_vat)
        }, 0);
      return sum.toFixed(2);
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },

    sentToMyData(){
      let self = this;
      let invoiceID = self.$route.params.id;
      // TODO can not be execute if mark is defined

      axios.get('/api/invoices/createMark/'+ self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
        .then(function(res){

            self.message = 'Επιτυχής απόκτηση MARK';
            self.showAlert();
            // self.mark = res.data.mark;
            // self.uid = res.data.uid;
            // self.date_mark_created = res.data.date_mark_created;

            self.$router.push({name: 'EditInvoice', params: {id: invoiceID}});
        }).catch(function(e){
            self.message = e.response.data.message;
            self.showAlert();
            if(error.response.data.message == 'The given data was invalid.'){
              self.messageMYDATA = '';
                for (let key in error.response.data.errors) {
                  if (error.response.data.errors.hasOwnProperty(key)) {
                    self.messageMYDATA += error.response.data.errors[key][0] + '  ';
                  }
                }
            }else{
              self.$router.push({ path: '/login' });
            }
        });
    },

    printInvoice() {
      if (this.isBQVLogoUploaded == 0) {
        // logo is not uploaded, terminate the printing
        this.message = 'Για να πραγματοποιηθεί εκτύπωση τιμολογίου πρέπει πρώτα να έχετε ανεβάσει το λογότυπο της εταιρείας στην καρτέλα "Ρυθμίσεις εταιρείας".';
        this.showAlert();
      } else {
        // logo is uploaded, print
        if (this.invoice_language == 'greek') {
          var headers = [[
            "ΥΠΗΡΕΣΙΑ",
            "ΠΟΣΟΤΗΤΑ",
            "ΤΙΜΗ",
            "ΠΟΣΟ",
          ]];
          var headersInvoiceInfo = [[
            "ΣΤΟΙΧΕΙΑ ΤΙΜΟΛΟΓΙΟΥ",
            "ΤΥΠΟΣ ΠΑΡΑΣΤΑΤΙΚΟΥ",
            "ΣΕΙΡΑ ΠΑΡΑΣΤΑΤΙΚΟΥ",
          ]];
        } else if (this.invoice_language == 'english') {
          var headers = [[
            "SERVICE",
            "QUANTITY",
            "PRICE",
            "AMOUNT",
          ]];
          var headersInvoiceInfo = [[
            "INVOICE INFORMATION",
            "DOCUMENT TYPE",
            "DOCUMENT SERIES",
          ]];
        }

        var doc = new jsPDF({orientation: 'a4', compress: true});
        doc.addFileToVFS('Roboto-Regular.ttf', Roboto);
        doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold);
        doc.addFileToVFS('Roboto-Italic.ttf', RobotoItalic);

        doc.addFont('Roboto-Regular.ttf', 'custom', 'normal');
        doc.addFont('Roboto-Bold.ttf', 'custom', 'bold');
        doc.addFont('Roboto-Italic.ttf', 'custom', 'italic');

        doc.setFont('custom', 'normal');




        if (this.BQVLogoUrl) {
          doc.addImage(this.BQVLogoUrl, 'PNG', 15, 12, 55, 20, undefined, 'FAST');
        }

        if(this.qr_url.length > 0){
          const canvasQR = document.querySelector('.qr-image canvas');
          const base64Canvas = canvasQR.toDataURL("image/jpeg").split(';base64,')[1];
          doc.addImage(base64Canvas, 'JPEG', 165, 90, 30, 30, undefined, 'FAST');
        }

        var img = new Image();
        img.src = '/images/signature.png'; // the signature


        doc.setFontSize(18);
        doc.setFont('custom', 'bold');
        doc.text(this.BQVInfoName, 15, 48);

        doc.setFontSize(11);
        doc.setFont('custom', 'italic');
        if (this.invoice_language == 'greek') {
          doc.text('"'+this.BQVInfoMotto+'"', 15, 54);
        } else if (this.invoice_language == 'english') {
          doc.text('"'+this.BQVInfoMottoEn+'"', 15, 54);
        }

        doc.setFontSize(10);
        doc.setFont('custom', 'normal');
        if (this.invoice_language == 'greek') {
          doc.text(this.BQVaddress.replaceAll("<br>", "\n").replaceAll("<p>", "").replaceAll("</p>", "\n") + '\n', 152.5, 13.5);
          doc.text(this.generateDataBQVInfo(), 152.5, 22);

          doc.autoTable({
            startY: 61,
            theme: 'grid',
            styles: { font: 'custom' },
            head: headersInvoiceInfo,
            headStyles: {
              lineWidth: 0.1,
              lineColor: '#cacaca'
            },
            didParseCell: function (table) {
              if (table.section === 'head') {
                table.cell.styles.fillColor = '#ffffff';
                table.cell.styles.textColor  = '#000000';
              }
              if (table.section === 'body') {
                table.cell.styles.fillColor = '#ffffff';
                table.cell.styles.textColor  = '#000000';
              }
            },
            body: this.generateDataInvoiceMainInfo()
          });

          doc.setFont('custom', 'bold');
          doc.text('ΣΤΟΙΧΕΙΑ ΠΕΛΑΤΗ: ', 15, 90);
          doc.setFont('custom', 'normal');
          var splitTitle = doc.splitTextToSize(this.generateDataClientInfo(), 180);
          doc.text(15, 96, splitTitle);

        }
        else if (this.invoice_language == 'english') {
          doc.text(this.BQVaddressEN.replaceAll("<br>", "\n").replaceAll("<p>", "").replaceAll("</p>", "\n") + '\n', 152.5, 13.5);
          doc.text(this.generateDataBQVInfoEN(), 152.5, 22);

          doc.autoTable({
            startY: 61,
            theme: 'grid',
            styles: { font: 'custom' },
            head: headersInvoiceInfo,
            headStyles: {
              lineWidth: 0.1,
              lineColor: '#cacaca'
            },
            didParseCell: function (table) {
              if (table.section === 'head') {
                table.cell.styles.fillColor = '#ffffff';
                table.cell.styles.textColor  = '#000000';
              }
              if (table.section === 'body') {
                table.cell.styles.fillColor = '#ffffff';
                table.cell.styles.textColor  = '#000000';
              }
            },
            body: this.generateDataInvoiceMainInfoEN()
          });

          doc.setFont('custom', 'bold');
          doc.text('BILL TO: ', 15, 90);
          doc.setFont('custom', 'normal');
          var splitTitleEn = doc.splitTextToSize(this.generateDataClientInfoEN(), 180);
          doc.text(splitTitleEn, 15, 96);
        }

        doc.autoTable({
          startY: 130,
          styles: { font: 'custom' },
          head: headers,
          didParseCell: function (table) {
            if (table.section === 'head') {
              table.cell.styles.fillColor = '#cacaca';
            }
          },
          body: this.generateData(this.invoices_cases)
        });

        if (this.invoice_language == 'greek') {
          var finalY = doc.lastAutoTable.finalY + 10
          doc.autoTable({
            startY: finalY,
            theme: 'grid',
            tableWidth: 60,
            pageBreak: 'avoid',
            margin: {left: 136},
            styles: { font: 'custom' },
            body: this.generateTotalAmountData()
          });

          var finalY = doc.lastAutoTable.finalY + 15
          doc.autoTable({
            startY: finalY,
            styles: { font: 'custom' },
            columnStyles: {
              0: {cellWidth: 'auto'},
              1: {cellWidth: 'auto'},
            },
            willDrawCell: function (data) {
              doc.setFillColor('#FFFFFF');
            },
            didParseCell: function (table) {
              table.cell.styles.textColor = '#000000';
            },
            body: [
              ['ΠΛΗΡΩΜΗ: \n' + this.BQVbank_accounts.replaceAll("<br>", "\n").replaceAll("<p>", "").replaceAll("</p>", "\n"), "ΥΠΟΓΡΑΦΗ\n"]
            ],
            didDrawCell: (data) => {
              if (data.section === 'body' && data.column.index === 1 && data.row.index == 0) {
                doc.addImage(img, 'png', 155, data.cell.y + 10, 35, 20, undefined, 'FAST');
              }
            },
          });

          finalY = doc.lastAutoTable.finalY + 20;
          let pageWidth = doc.internal.pageSize.getWidth();


          doc.text((pageWidth / 2) - 35, finalY, 'ΕΥΧΑΡΙΣΤΟΥΜΕ ΓΙΑ ΤΗΝ ΠΡΟΤΙΜΗΣΗ ΣΑΣ!');

          if (this.client_type.includes('InvoiceClients')) {
            doc.save(`invoice_${this.document_number.toString()+'_'+this.client_name}_GR.pdf`);
          } else {
            doc.save(`invoice_${this.document_number.toString()+'_'+this.client_company}_GR.pdf`);
          }
        }
        else if (this.invoice_language == 'english') {
          var finalY = doc.lastAutoTable.finalY + 10
          doc.autoTable({
            startY: finalY,
            tableWidth: 60,
            pageBreak: 'avoid',
            margin: {left: 136},
            theme: 'grid',
            styles: { font: 'custom' },
            body: this.generateTotalAmountDataEN()
          });

          var finalY = doc.lastAutoTable.finalY + 15
          doc.autoTable({
            startY: finalY,
            styles: { font: 'custom' },
            columnStyles: {
              0: {cellWidth: 'auto'},
              1: {cellWidth: 'auto'},
            },
            willDrawCell: function (data) {
              doc.setFillColor('#FFFFFF');
            },
            didParseCell: function (table) {
              table.cell.styles.textColor = '#000000';
            },
            body: [
              ['BANKING DETAILS: \n' + this.BQVbank_accountsEN.replaceAll("<br>", "\n").replaceAll("<p>", "").replaceAll("</p>", "\n"), "SIGNATURE"]
            ],
            didDrawCell: (data) => {
              if (data.section === 'body' && data.column.index === 1 && data.row.index == 0) {
                doc.addImage(img, 'png', 155, data.cell.y + 10, 35, 20, undefined, 'FAST');
              }
            },
          });

          var finalY = doc.lastAutoTable.finalY + 20;
          let pageWidth = doc.internal.pageSize.getWidth();

          doc.text((pageWidth / 2) - 35, finalY, 'THANK YOU FOR YOUR PREFERENCE!');

          if (this.client_type.includes('InvoiceClients')) {
            doc.save(`invoice_${this.document_number.toString()+'_'+this.client_name}_EN.pdf`);
          } else {
            doc.save(`invoice_${this.document_number.toString()+'_'+this.client_company}_EN.pdf`);
          }
        }
      }
    },



    generateTotalAmountData() {
      let result = [
        ["ΜΕΡΙΚΟ ΑΘΡΟΙΣΜΑ", this.subtotal + '€'],
        ["ΦΠΑ " + this.fpa100 + "%", this.fpa + '€'],
        ["ΣΥΝΟΛΟ", this.total + '€']
      ];

      return result;
    },
    generateTotalAmountDataEN() {
      let result = [
        ["SUB TOTAL", this.subtotal + '€'],
        ["TOTAL", this.total + '€']
      ];

      return result;
    },
    generateData(services) {
      if (!services || !Array.isArray(services)) {
        return [];
      }

      var result = services
        .filter(item => item !== null && item !== undefined)
        .map((item) => {
          return [
            this.getServiceName(item.id),
            item.service_quantity || 0,
            (item.price_without_vat / (item.service_quantity || 1)).toFixed(2) + '€',
            item.price_without_vat + '€',
          ]
        })

      return result;
    },
    generateDataInvoiceMainInfo() {
      let infoFields = [[
        'ΗΜΕΡΟΜΗΝΙΑ: ' + this.invoice_date + '\n' + 'ΑΡΙΘΜΟΣ ΤΙΜΟΛΟΓΙΟΥ: ' + this.document_number + '\n' + 'MARK: ' + this.mark,
        this.document_series,
        this.document_series_seira,
      ]];

      return infoFields;
    },
    generateDataInvoiceMainInfoEN() {
      let infoFields = [[
        'DATE: ' + this.invoice_date + '\n' + 'INVOICE NUMBER: ' + this.document_number + '\n' + 'MARK: ' + this.mark,
        this.document_series,
        this.document_series_seira
      ]];

      return infoFields;
    },
    generateDataBQVInfo() {
      let BQVInfo = [
        this.BQVphone_number_1 + '\n',
        this.BQVphone_number_2 + '\n',
        'ΑΦΜ: ' + this.BQVvat + '\n',
        'ΔΟΥ: ' + this.BQVdoy + '\n',
        'ΑΡ. Γ.Ε.ΜΗ: 155865601000\n',
        this.BQVemail + '\n',
        this.BQVwebsite + '\n'
      ];

      return BQVInfo;
    },
    generateDataBQVInfoEN() {
      let BQVInfo = [
        this.BQVphone_number_1 + '\n',
        this.BQVphone_number_2 + '\n',
        'VAT: ' + this.BQVvatEN + '\n',
        'G.E.MI: 155865601000\n',
        this.BQVemail + '\n',
        this.BQVwebsite + '\n'
      ];

      return BQVInfo;
    },
    generateDataClientInfo() {
      let clientInfo = [
        'Επωνυμία εταιρείας: ' + this.client_company + '\n',
        this.client_name ? 'Υπεύθυνος Επικοινωνίας: ' + this.client_name + '\n' : 'Υπεύθυνος Επικοινωνίας: -\n',
        'Οδός και αριθμός: ' + this.client_address + '\n',
        this.client_postcode ? 'Πόλη, νομός, Τ.Κ.: ' + this.client_town + ', ' + this.client_state + ', ' + this.client_postcode + '\n' : 'Πόλη, νομός: ' + this.client_town + ', ' + this.client_state + '\n',
        'Τηλέφωνο Επικοινωνίας (1): ' + this.client_phone + '\n',
        this.client_phone_2 ? 'Τηλέφωνο Επικοινωνίας (2): ' + this.client_phone_2 + '\n' : 'Τηλέφωνο Επικοινωνίας (2): -\n',
        'ΑΦΜ: ' + this.client_afm + '\n',
        'ΔΟΥ: ' + this.client_doy + '\n'
      ];

      return clientInfo;
    },
    generateDataClientInfoEN() {
      let clientInfo = [
        'Company: ' + this.client_company + '\n',
        this.client_name ? 'Contact Person: ' + this.client_name + '\n' : 'Contact Person: -\n',
        'Address: ' + this.client_address + '\n',
        this.client_postcode ? 'Town, State, Postcode: ' + this.client_town + ', ' + this.client_state + ', ' + this.client_postcode + '\n' : 'Town, State: ' + this.client_town + ', ' + this.client_state + '\n',
        'Phone (1): ' + this.client_phone + '\n',
        this.client_phone_2 ? 'Phone (2): ' + this.client_phone_2 + '\n' : 'Phone (2): -\n',
        'VAT: ' + this.client_afm + '\n',
      ];

      return clientInfo;
    },
    generateDataInvoiceInfo() {
      let invoiceInfo = [
        'ΗΜΕΡΟΜΗΝΙΑ: ' + this.invoice_date + '\n',
        'ΑΡΙΘΜΟΣ ΤΙΜΟΛΟΓΙΟΥ: ' + this.document_number + '\n'
      ];

      return invoiceInfo;
    },
    generateDataInvoiceInfoEN() {
      let invoiceInfo = [
        'DATE: ' + this.invoice_date + '\n',
        'INVOICE NUMBER: ' + this.document_number + '\n'
      ];

      return invoiceInfo;
    },
    createHeaders(keys) {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
        result.push({
          id: keys[i],
          name: keys[i],
          prompt: keys[i],
          width: 65,
          align: "center",
          padding: 0
        });
      }
      return result;
    }
  },
  mounted: function(){
    let self = this;
    self.getInvoice();
  }
}

</script>
